import { isExternalLink } from '../isExternalLink';

export const buildBannerLink = (
  banner: GQL.IBanner,
  language: string
) => {
  if (banner && banner.link) {
    if (isExternalLink(banner.link)) {
      return banner.link;
    }

    return '/' + language + (banner.link.charAt(0) !== '/' ? '/' : '') + banner.link;
  }

  return null;
};


// WEBPACK FOOTER //
// ./src/helpers/banners/buildBannerLink.ts